import React from 'react';
import BottomNav from '../components/BottomNav';

const WealthFinanceFiduciary = () => {
  return (
    <div className="page-container">
      <div className="page-wrapper">
        <h1 className="page-title">Wealth & Finance Fiduciary</h1>
        <div className="underline"></div>
        <p className="page-subtitle">Expert Financial Management</p>
        
        <div className="card">
          <p>
            Comprehensive wealth management and fiduciary services. Our experts provide 
            strategic guidance to preserve and grow your financial legacy.
          </p>
          
          <div className="service-features">
            <div className="feature-item">
              <h3>Portfolio Management</h3>
              <p>Strategic investment planning and execution</p>
            </div>
            <div className="feature-item">
              <h3>Tax Optimization</h3>
              <p>Efficient tax strategies to maximize wealth retention</p>
            </div>
            <div className="feature-item">
              <h3>Fiduciary Services</h3>
              <p>Trusted advisors acting in your best interest</p>
            </div>
          </div>
        </div>
      </div>
      
      <BottomNav />
    </div>
  );
};

export default WealthFinanceFiduciary;
